export default __webpack_public_path__ + "static/media/icn-small-error.30b04f05.svg";